<template>
    <div class="d-flex flex-wrap">
        <v-btn
            outlined
            text
            :color="color"
            :type="type"
            @click="contact = true"
        >
            {{buttontext | translate}}
        </v-btn>

        <v-row justify="center">
        <v-dialog v-model="contact" max-width="500">
            <v-card>
            <v-card-title v-if="isCompanyRep" class="headline">{{ 'Send Message to Group/Users' | translate }}</v-card-title>
            <v-card-title v-else class="headline">{{ 'Write to Company Representative' | translate }}</v-card-title>
            <v-card-text>
                <v-row v-if="message!== null">
                <v-col cols="12" sm="12">
                    <v-alert dense outline type="success">{{ message | translate }}</v-alert>
                </v-col>
                </v-row>
                <v-form ref="contactForm" lazy-validation>
                <div v-if="isCompanyRep">
                    <v-row>
                    <v-col cols="12" sm="12">
                    <v-autocomplete
                        v-model="sendGroup"
                        :items="recipientType"
                        item-value="value"
                        item-text="text"
                        :label="'Select Recipient Type' | translate"
                        outlined
                        chips
                        small-chips
                        required
                        disabled
                        :no-data-text="$t('No data available')"
                        >
                        <template #message="{ message }">
                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                        </template>
                        </v-autocomplete>
                    </v-col>
                    </v-row>

                    <div v-if="sendGroup">
                    <v-row v-if="sendGroup=='group'">
                    <v-col cols="12" sm="12">
                        <v-autocomplete
                        v-model="userGroupList"
                        :items="groups"
                        item-value="group_id"
                        :item-text="item =>`${item.group_name}`"
                        :label="'User Group' | translate"
                        outlined
                        chips
                        small-chips
                        multiple
                        required
                        disabled
                        :no-data-text="$t('No data available')"
                        >
                        <template #message="{ message }">
                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                        </template>  

                        </v-autocomplete>
                    </v-col>
                    </v-row>
                    <v-row v-else>
                    <v-col cols="12" sm="12">
                        <v-autocomplete
                        v-model="userList"
                        :items="users"
                        item-value="user_id"
                        :item-text="item =>`${item.name} (${item.email})`"
                        :label="'Users' | translate"
                        outlined
                        chips
                        small-chips
                        multiple
                        required
                        disabled
                        :no-data-text="$t('No data available')"
                        >
                        <template #message="{ message }">
                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                        </template>  

                        </v-autocomplete>
                    </v-col>
                    </v-row>
                    </div>
                </div>

                <v-row>
                    <v-col cols="12" sm="12">
                    <v-text-field
                        v-model="subject"
                        name="subject"
                        :rules="[v => !!v || 'Subject is required']"
                        :label=" 'Subject' | translate"
                        required
                    >
                    <template #message="{ message }">
                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>                  
                    </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="12">
                    <v-textarea
                        outlined
                        name="body"
                        v-model="body"
                        :rules="[v => !!v || 'Body is required']"
                        :label=" 'Body' | translate"
                    >
                    <template #message="{ message }">
                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>                   
                    </v-textarea>
                    </v-col>
                </v-row>

                <v-checkbox v-model="sendCopy" :label="'Send copy to myself' | translate"></v-checkbox>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary darken-1" text @click="contact = false">{{ 'Close' | translate}}</v-btn>

                <v-btn color="primary darken-1" text @click="contactQuery">{{ 'Submit' | translate }}</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="navSuccessMessageDialog" persistent max-width="560">
            <v-card>
            <v-card-title class="headline">{{ message| translate }}</v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="navSuccessMessageDialog = false">{{ 'Close'| translate }}</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>

        </v-row>
    </div>
</template>


<script>
    import {
    CONTACT_QUERY,
    FETCH_USERS,
    FETCH_GROUPS,
    } from "@/store/actions.type";
    import {
    SET_LOADING,
    } from "@/store/mutations.type";
    import { mapGetters } from "vuex";
    export default {
    name: "Message",
    props:{
        buttontext: String,
        color: String,
        type: String,
        sendUserList: Number,
        notificationId:Number,
    },
    watch: {
        contact(value) {
        if (value) {
            this.message = null;
            this.body = null;
            this.subject = null;
            this.sendCopy = false;
            this.sendGroup = this.type ? this.type : null ;
            this.userGroupList = null;
            this.userList = this.sendUserList ? this.sendUserList : null ;

            // Call the users and groups api for only people with access
            if(this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3) ){
                this.$store.dispatch(FETCH_USERS, '').then(resp => {
                if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                    this.$store.commit(SET_LOADING, false);
                    this.users = resp.data;
                }
                else{
                    this.$store.commit(SET_LOADING, false);
                }
                });
                this.$store.dispatch(FETCH_GROUPS, '').then(resp => {
                if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                    this.$store.commit(SET_LOADING, false);
                    this.groups = resp.data;
                }
                else{
                    this.$store.commit(SET_LOADING, false);
                }
                });
            }
        }
        },
    },
    data: () => ({
        dialog: false,
        items: [],
        contact: false,
        sendCopy: false,
        sendGroup: false,
        subject: "",
        body: "",
        message: null,
        navSuccessMessageDialog:false,
        userList:[],
        userGroupList:[],
        users : null,
    }),
    methods: {
        async contactQuery() {
        if (this.$refs.contactForm.validate()) {
            let params = {
                subject: this.subject,
                body: this.body,
                send_copy: this.sendCopy,
            };

            if(this.sendGroup=='group'){
            params["group_ids"] = this.userGroupList.toString();
            }
            else if(this.sendGroup=='users'){
            params["user_ids"] = this.userList.toString();
            }

            if(this.notificationId){
            params["notification_id"] = this.notificationId;
            }

            this.$store
            .dispatch(CONTACT_QUERY, params)
            .then(resp => {
                if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                this.message = "Query successfully sent";
                this.navSuccessMessageDialog = true;
                this.contact = false;
                this.$store.commit(SET_LOADING, false);
                }
                else{
                this.$store.commit(SET_LOADING, false);
                }
            });
        }
        },
    },
    computed: {
        ...mapGetters([
        "mini",
        "languages",
        "currentUser",
        'curLanguage',
        ]),
        recipientType(){
        return [
            {value: 'group', text:this.$t('Group')},
            {value: 'users', text:this.$t('Users')}
        ]
        },
        isCompanyRep: function() {
        return (this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3));
        },
        canSendMessages: function() {
            return (this.currentUser.permissions.includes('can-send-receive-messages'));
        },
    }
    };
</script>